import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsKloutComponent } from './simple-icons-klout.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsKloutComponent ],
    exports:      [ SimpleIconsKloutComponent ],
    bootstrap:    []
})
export class SimpleIconsKloutModule {}
